import { render, staticRenderFns } from "./EditPpm.vue?vue&type=template&id=1c79966a&"
import script from "./EditPpm.vue?vue&type=script&lang=js&"
export * from "./EditPpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports